export interface LinksListItem {
  name: string;
  url: string;
  isChild: boolean;
}
